module.exports = __webpack_public_path__ + "static/media/dodovet-qr-code.1f86ae03.png";